import { lazy, Suspense, type ComponentType, type ReactElement } from 'react'
import { PageLoading } from '../../app/PageLoading'
import { loadNamespace } from '../../i18n'

/**
 * A screen whose code loads on first visit. The route itself matches at once (so the bottom bar and
 * the address update immediately); the screen shows a loading state inside the shell while its chunk
 * arrives. A chunk that cannot load (offline, say) reaches the route's error boundary.
 */
export function lazyScreen(load: () => Promise<{ default: ComponentType }>): ReactElement {
  const Screen = lazy(() => Promise.all([load(), loadNamespace('member')]).then(([screen]) => screen))
  return (
    <Suspense fallback={<PageLoading />}>
      <Screen />
    </Suspense>
  )
}
